<template>
<div class="supplier-card card" @click="toDetail(info.id)">
  <div class="card-left">
    <VImg class="logo-img" v-if="info.isvImg" :attachment-id="info.isvImg"/>
    <div class="logo" :class="[`logo-color-${colorNum}`]">{{getFirstCode(info.name)}}</div>
  </div>
  <div class="card-right">
    <div>
      <div class="title" v-html="info.name"></div>
      <div class="text-overflow2 text" v-html="info.corpComment"></div>
    </div>
    <div>
      <div>
        <span>成立时间：{{info.establishmentDate}}</span>
        <span>企业规模：{{ info.companyScaleTypeName }}</span>
      </div>
      <div>企业网址：<span>{{info.website}}</span></div>
    </div>

  </div>
</div>
</template>

<script >
import VImg from '@/components/VImg.vue'

export default{
  props: {
    colorNum:{
      required: true
    },
    info:{}
  },
  data(){
    return{}
  },

  components: {VImg},
  methods:{
    toDetail(id) {
      this.$router.push({
        path: "/treasury/provider",
        query: { id },
      });
    },
    getFirstCode(name){
      let text= name.match(/[\u4e00-\u9fa5]/g)
      console.log(text,'text')
      return text.join("").slice(0,1)
    }
  }

}
</script>


<style scoped lang="scss">
.supplier-card{
  height: 162px;
  padding: 24px;
  display: flex;
  cursor: pointer;
  border-bottom: 1px solid #E8E8E8;
}
.card-left{
  margin-right: 12px;
  .logo-img{
    display: block;
    width: 80px;
    height: 80px;
  }
  .logo{
    width: 80px;
    height: 80px;
    border-radius: 4px;
    font-weight: 400;
    font-size: 48px;
    line-height: 78px;
    text-align: center;
  }
}
.card-right{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  >:first-child{
   .title{
     font-weight: 400;
     font-size: 16px;
     color: #262626;
     line-height: 22px;
     margin-bottom: 12px;
   }
    >.text{
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 20px;
    }
  }
  >:last-child{
    display: flex;
    justify-content: space-between;
    align-items: center;
    >:first-child{
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      >:first-child{
        margin-right: 24px;
      }
    }
    >:last-child{
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      >span{
        color: #4181FC;
      }
    }
  }
}
</style>
